import axios from 'axios';
import { Constants } from '../Constants';

export const add = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const addLotsMassive = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/addMassive`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const getLots = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        let query = '';
        if (data.page) {
            query += query === '' ? `?page=${data.page}` : `&page=${data.page}`
        }
        if (data.auction !== null) {
            query += query === '' ? `?auction=${data.auction}` : `&auction=${data.auction}`
        }
        if (data.offset) {
            query += query === '' ? `?offset=${data.offset}` : `&offset=${data.offset}`
        }
        if (data.filterStatus) {
            query += query === '' ? `?filterStatus=${data.filterStatus}` : `&filterStatus=${data.filterStatus}`
        }
        if (data.orderLots) {
            query += query === '' ? `?orderLots=${data.orderLots}` : `&orderLots=${data.orderLots}`
        }
        return await axios.get(`${Constants.BASE_URL}lots${query}`, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const getLotsForDelivery = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        let query = '';
        if (data.auction !== null) {
            query += '?auction=' + data.auction;
        }
        return await axios.get(`${Constants.BASE_URL}customers/pending_lots/${data.userId}${query}`, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const getLotsByUser = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.get(`${Constants.BASE_URL}customers/lots_by_user/${data.userId}`, httpOptions);
    } catch (error) {
        throw error;
    }
}


export const getLotsForLiquidate = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.get(`${Constants.BASE_URL}customers/liquidated_lots/${data.customerId}`, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const deliveryLots = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/deliveryLots`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const invoiceLots = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/invoicieLots`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const getBestOffers = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.get(`${Constants.BASE_URL}offers/bestOffers/${data.lot}`, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const assignForceWin = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/assignForceWin`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const removeWin = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/removeWin`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const calculateTotals = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/calculateTotals`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const calculateTotalsLiquid = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}customers/calculate_totals_liquidate`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const changeRemision = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/changeRemision`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const importLots = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/importLots`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const printRemitterLiquid = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}customers/print_liquidated_lots`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const deleteOffer = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}offers/delete`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const acceptSuggestedOffer = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}offers/acceptSuggested`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}

export const invoiceLiquidation = async (data) => {
    try {
        const httpOptions = {
            headers: {
                'Authorization': data.token
            }
        };
        return await axios.post(`${Constants.BASE_URL}lots/invoice_liquidation`, data, httpOptions);
    } catch (error) {
        throw error;
    }
}